import { CommonModel } from '../common';

export enum ApplicableFor {
  BUSINESS = 'BUSINESS',
  FAMILY = 'FAMILY',
}

export enum Validity {
  INACTIVE = 'INACTIVE',
  EXPIRED = 'EXPIRED',
  ACTIVE = 'ACTIVE',
}

export enum BillingPeriod {
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
}

export enum SubscriptionFeatureType {
  SECONDARY = 'SECONDARY',
  PRIMARY = 'PRIMARY',
}

export enum SubscriptionCompanyPolicyFeatureName {
  PUBLIC_TRANSPORT = 'PUBLIC_TRANSPORT',
  PARKINGS = 'PARKINGS',
  HIGHWAYS = 'HIGHWAYS',
}

export enum ResourceType {
  EMPLOYEE = 'EMPLOYEE',
  VEHICLE = 'VEHICLE',
  GREATER = 'GREATER',
}

export interface SubscriptionFeature extends CommonModel {
  serviceName: string;
  icon: string;
  type: SubscriptionFeatureType;
}

export interface SubscriptionCompanyPolicyFeature extends CommonModel {
  name: string;
  features: SubscriptionCompanyPolicyFeatureName[];
}

export interface SubscriptionDowngradeQuestion extends CommonModel {
  question: string;
}

export interface AvailableForCompanyType extends CommonModel {
  availableForCompanyType: string;
  name: string;
}

export interface Subscription extends CommonModel {
  name: string;
  applicableFor: ApplicableFor;
  startDate: string;
  endDate: string | null;
  validity: Validity;
  isDefault: boolean;
  billingPeriod: BillingPeriod;
  billingUnit: ResourceType;
  costPerUnit: number;
  learnMoreUrl: string;
  learnMoreLabel: string;
  subscriptionFeatures: SubscriptionFeature[];
  subscriptionCompanyPolicyFeatures: SubscriptionCompanyPolicyFeature[];
  availableForCompanyType: AvailableForCompanyType[];
  subscriptionDowngradeQuestions: SubscriptionDowngradeQuestion[];
  rank: number;
}
